import { type DeviceDefinitionDto, useDeviceDefinition } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import { CatalogDefinition, DeviceDefinitionRead } from "@/features/catalog";
import { useDefinitionChangePoints, useDefinitionView } from "@/features/catalog/hooks/use-definition-as-of";
import { asOfSearchSchema } from "@/features/catalog/lib/as-of-search";
import { deviceDefinitionUrlFromRouteId } from "@/features/catalog/lib/device-definition-route";

export const Route = createFileRoute("/catalog/devices/$deviceId")({
  component: DeviceDetail,
  validateSearch: asOfSearchSchema,
});

function DeviceDetail() {
  const { deviceId } = Route.useParams();
  const { asOf } = Route.useSearch();
  const { permissions } = Route.useRouteContext();
  const definitionUrl = deviceDefinitionUrlFromRouteId(deviceId);
  const live = useDeviceDefinition(asOf ? undefined : definitionUrl);
  const view = useDefinitionView<DeviceDefinitionDto>(definitionUrl, asOf, live);
  const { changePoints } = useDefinitionChangePoints(definitionUrl);

  if (view.isPending) return <CatalogDefinition.Pending />;
  if (!view.definition) {
    return <CatalogDefinition.NotFound label="Device" backTo="/catalog/devices" backLabel="Back to devices" />;
  }

  return (
    <DeviceDefinitionRead
      key={`${deviceId}|${asOf ?? "latest"}`}
      definition={view.definition}
      deviceId={deviceId}
      asOf={asOf}
      changePoints={changePoints}
      canEdit={!view.isPast && permissions.canWrite("DeviceDefinition")}
    />
  );
}
